module.exports = __webpack_public_path__ + "static/media/bootstrap.eaed0693.png";